import { FunctionComponent } from 'react';

const ErrorComponent: FunctionComponent<Record<string, never>> = () => {
  return <div>Error!!!</div>;
};

export default ErrorComponent;
